<template>
  <div :class="getSatellite ? 'cart shorten' : 'cart'">
    <p v-show="!products.length">Your cart is empty.</p>
    <table class="table is-striped" v-if="products.length && this.$store.getters.allProducts.length">
      <thead>
        <tr>
          <th>Name</th>
          <th v-if="!itemPay">Quantity</th>
          <th v-if="itemPay">Add Item to Eftpos</th>
          <th>Price/unit</th>
        </tr>
      </thead>
      <tbody>
        <tr class="product-divider" v-for="p in products" :key="p.id">
          <!-- <td @click="addItemToPayment(p)">Add to Payment</td> -->
          <td @click="loadItem(p)">
            <h4>{{ p.name }}</h4>
            <ul>
              <span :key="modifier" v-for="modifier in p.modifiers">
                <li :key="modifier + '-' + m" v-for="m in modifier">
                  {{ m.name }}
                </li>
              </span>
            </ul>
          </td>
          <td>
            <p v-if="!itemPay">
              <b class="cart-symbol" @click="changeLineItemQuantityWrapper(p.hash, -1)"><font-awesome-icon class="quantity-icon" icon="minus-circle" /></b>
              <span class="quantity">{{ p.quantity }}</span>
              <b class="cart-symbol" @click="changeLineItemQuantityWrapper(p.hash, 1)"><font-awesome-icon class="quantity-icon" icon="plus-circle" /></b>
            </p>
            <p v-else>
              <!-- <p v-if="payingPrice > total">Paying more than total</p> -->
              <b class="cart-symbol" @click="addItemToPayment(p), addPrice(p)"><font-awesome-icon class="quantity-icon" icon="plus-circle" /></b>
            </p>
          </td>
          <td><CurrencyFormatter :value="p.price" :currency="currency" /></td>
        </tr>
        <tr v-if="siteSettings.surcharge">
          <td class="payment"><b>Holiday Surcharge:</b></td>
          <td>{{ 100 * surcharge.percentage }}%</td>
          <td><CurrencyFormatter :value="surchargeTotal" :currency="currency" /></td>
        </tr>
        <tr>
          <td><b>Total:</b></td>
          <td></td>
          <td><CurrencyFormatter :value="total" :currency="currency" /></td>
        </tr>
        <tr class="product-divider payment" v-for="(payment, idx) in payments" :key="payment + '-' + idx">
          <td class="payment">{{ payment.type }}</td>
          <td class="trash">
            <font-awesome-icon icon="fa-solid fa-trash" class="bin-icon" @click="deletePayment(idx, payment)" />
          </td>
          <td><CurrencyFormatter :value="parseFloat(payment.value)" :currency="currency" /></td>
        </tr>

        <tr>
          <td><b>Paid:</b></td>
          <td></td>
          <td>
            <b><CurrencyFormatter :value="parseFloat(paid)" :currency="currency" /></b>
          </td>
        </tr>

        <tr>
          <td><b>Balance:</b></td>
          <td v-if="!itemPay"></td>
          <td v-if="itemPay" class="cart-symbol" @click="addItemToPayment(remaining, true)"><font-awesome-icon class="quantity-icon" icon="plus-circle" /></td>
          <td>
            <b><CurrencyFormatter :value="parseFloat(remaining)" :currency="currency" /></b>
          </td>
        </tr>

      </tbody>
    </table>
    <!-- <div class="kiosk-buttons" v-if="getKiosk && products.length">
      <button class="kiosk-checkout" @click.stop.prevent="openKioskCheckout = true">Complete Order</button>
      <button class="start-again" @click.stop.prevent="confirmModal(false, 'Are you sure you want to start again')">Start Again</button>
    </div> -->
    <div v-if="$parent.$options.name !== 'CheckoutModal'" class="buttons" :class="kioskClass">
      <button
        v-if="!getKiosk && !getSatellite && !hideCheckoutButton && products.length"
        class="clear-button"
        @click="confirmModal(false, 'Are you sure you want to delete your cart')">
        <font-awesome-icon icon="fa-solid fa-trash" class="bin-icon" />
      </button>
      <button v-if="getKiosk" class="start-again" @click.stop.prevent="confirmModal(false, 'Are you sure you want to start again')">Start again</button>
      <button v-if="!getSatellite && !hideCheckoutButton && products.length" class="primary checkout-button action-colour" @click="showCheckoutModal">Checkout</button>
      <button v-if="getSatellite && products.length" class="primary checkout-button" @click="$emit('showSatelliteModal')">Confirm</button>
    </div>

    <div class="order-allergens" v-if="siteSettings.trackAllergens && orderAllergens.length">
      <h4>Allergens in your order:</h4>
      <ul >
        <li v-for="allergen in orderAllergens" :key="allergen">{{ allergen }}</li>
      </ul>

      <p v-if="conflictingAllergens">There are conflicting allergens in your order.</p>
    </div>
    <!-- {{ getKioskOrderDetails }} -->
  </div>
  <Confirm :open="openConfirm" :message="confirmModalMsg" :isDeleteConfirm="true" @confirmModal="confirmModal" @close="closeModal" />
  <!-- <KioskCheckout :open="openKioskCheckout" @close="openKioskCheckout = false" /> -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Confirm, CurrencyFormatter } from "@monolith/components";
// import KioskCheckout from "./KioskCheckout.vue";

export default {
  data() {
    return {
      checkoutProceed: true,
      surcharge: {
        percentage: 0.15,
        total: 0,
      },
      openConfirm: false,
      confirmModalMsg: "Are you Sure?",
      openKioskCheckout: false,
      payingPrice: 0,
    };
  },
  components: {
    Confirm,
    // KioskCheckout,
    CurrencyFormatter,
  },
  props: {
    hideCheckoutButton: { type: Boolean, default: false },
    allowSplit: { type: Boolean, default: false },
    itemPay: { type: Boolean, default: false, required: false },
  },

  mounted() {
  },

  emits: ["loadOrderLineItem", "showCheckoutModal", "showTab", "clearPayments", "showSatelliteModal", "addItemToPayment"],

  methods: {
    addPrice(item) {
      this.payingPrice += item.price;
    },

    closeModal() {
      console.log("closed modal");
    },

    checkMods() {
      let mods = [];
      this.checkoutProceed = true;
      this.products.forEach((prod) => {
        Object.keys(prod.modifiers).forEach((modifierset) => {
          let foundModifierSet = this.modifier_sets.find((m) => {
            return m.value._id === modifierset;
          });

          if (foundModifierSet && foundModifierSet.value.rules) {
            if (foundModifierSet.value.rules.inventory) {
              /* send to web socket */
              prod.modifiers[modifierset].forEach((mod) => {
                this.channel
                  .push("modifier:get:quantity", {
                    modifierset: modifierset,
                    modifier: mod,
                  })
                  .receive("ok", (reply) => {
                    mods.push(reply);
                    this.checkoutProceed = false;
                  });
              });
              let proceed = mods;
            }
          }
        });
      });
      if (this.checkoutProceed) {
        this.showCheckoutModal();
      } else {
        this.$notify({
          text: "Products currently unavailable, please choose again.",
          type: "error",
          duration: 1500,
        });
      }
    },
    addItemToPayment(product, remaining = false) {
      this.$emit("addItemToPayment", product, remaining);
    },
    deletePayment(idx, payment) {
      if (payment.type.includes("account") || payment.type.includes("voucher")) {
        const currentAccount = {
          ID: payment.id,
          name: payment.name,
          value: payment.value,
          doc_type: "credit",
          date: new Date().toISOString(),
        };
        this.channel.push(`${payment.type}:doc`, currentAccount);
      }
      this.$store.dispatch("deletePayment", idx);
    },
    changeLineItemQuantityWrapper(productHash, delta) {
      if (delta) {
        let currentProduct = this.products.find((lineItem) => lineItem.hash === productHash);
        this.changeCartDelta(currentProduct, delta);

        this.changeLineItemQuantity({ productHash: productHash, delta: delta });
      }
      if (!this.products.length) {
        this.$store.dispatch("clearPayments");
      }
    },
    confirmModal(action, msg) {
      this.confirmModalMsg = msg;
      if (action) {
        this.$store.dispatch("clearCart");
        this.$store.dispatch("setHoldingAccount", null);
        if (this.getKiosk) {
          this.$store.dispatch("setKioskDetails", null);
          this.$router.push("/startOrder");
        }
        this.$notify({
          text: "Cart Cleared",
          type: "success",
          duration: 1500,
        });
      }
      this.openConfirm = !this.openConfirm;
    },
    changeCartDelta(currentProduct, delta) {
      Object.keys(currentProduct.modifiers).forEach((modifierset) => {
        let foundModifierSet = this.modifier_sets.find((m) => {
          return m.value._id === modifierset;
        });

        if (foundModifierSet && foundModifierSet.value.rules) {
          if (foundModifierSet.value.rules.inventory) {
            /* send to web socket */
            currentProduct.modifiers[modifierset].forEach((modifierDeltaChange) => {
              this.channel.push("modifier:set:delta", {
                modifierset: modifierset,
                modifier: modifierDeltaChange,
                delta: delta * -1, // the modifiers available is the opposite of line item quantity
              });
            });
          }
        }
      });
    },
    ...mapActions(["changeLineItemQuantity"]),
    async showCheckoutModal() {
      //await this.$store.commit('setStripeTotalMutation', this.total * 100);
      this.$emit("showCheckoutModal", true);
    },
    loadItem(lineItem) {
      this.$emit("loadOrderLineItem", lineItem);
    },
  },
  computed: {
    ...mapGetters({
      getClosed: "getClosed",
      products: "cartProducts",
      allProducts: "allProducts",
      payments: "cartPayments",
      modifier_sets: "modifier_sets",
      siteSettings: "siteSettings",
      getKiosk: "getKiosk",
      getKioskOrderDetails: "getKioskOrderDetails",
      getSatellite: "getSatellite",
      currency: "currency",
      allergensProducts: "allergensProducts",
      orderAllergens: "orderAllergens",
      conflictingAllergens: "conflictingAllergens",
    }),
    surchargeTotal() {
      const total = this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
      return this.surcharge.percentage * total;
    },
    ccTotal() {
      const total = this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
      return 0.03 * total;
    },
    total() {
      let total = this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
      if (this.siteSettings.surcharge) {
        total += this.surchargeTotal;
      }
      return total;
    },
    paid() {
      return this.payments.reduce((total, p) => {
        return total + p.value;
      }, 0);
    },
    remaining() {
      return this.total - this.paid;
    },

    kioskClass() {
      return this.getKiosk ? "kiosk-buttons" : "cart-buttons";
    },
  },
  watch: {
    products() {
      let companion = { products: this.products, payment: this.payments };
      if (this.siteSettings.surcharge) {
        companion["surcharge"] = true;
        companion["surchargeTotal"] = this.surchargeTotal;
      }
      this.channel.push("cart:state", companion);
    },
  },
};
</script>
<style scoped lang="scss">
.shorten {
  margin-bottom: 5rem;
}
.cart {
  position: relative;
  border-radius: 1rem 0rem 0rem 0rem;
  .cart-title {
    margin: 0;
  }
  div {
    .previous-order {
      margin: 0;
      border: 0;
    }
  }
}
.cart-symbol {
  padding: 0rem;
  //1rem 0rem 1rem;
  font-size: x-large;
  color: var(--warning-colour);
}

.cart_symbol:hover {
  cursor: pointer;
}

table {
  width: 100%;
  overflow-y: scroll;
  tr th {
    font-weight: 700;
  }

  td {
    text-align: center;
    vertical-align: top;
    padding: 0.5rem 0;
    p {
      margin: 0px;
      line-height: 1rem;
    }
  }
  th:nth-child(1),
  td:nth-child(1) {
    text-align: left;
    // width: 250px;
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 80px;

    .quantity-icon {
      color: var(--action-colour);
    }

    span.quantity {
      margin: 0px 10px 0px 5px;
      display: inline-block;
      width: 5px;
      vertical-align: 4px;
    }
  }
  th:nth-child(3),
  td:nth-child(3) {
    text-align: right;
    width: 80px;
  }

  .product-divider.payment {
    text-transform: capitalize;
  }
  .product-divider td {
    border-bottom: 1px solid #555;
  }
  .trash {
    color: var(--action-colour);
  }
}

h2 {
  margin-top: 0px;
  padding-top: 1rem;
  span:nth-of-type(2) {
    color: #aaa;
  }
  cursor: pointer;
}

h4 {
  margin: 0px;
}

ul {
  display: block !important;
  list-style: none;
  margin: 0px;
  margin-top: 1rem;
  padding: 0px;

  li {
    margin-bottom: 0.5rem;
  }
}

.kiosk-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: sticky;
  bottom: 0.5rem;
  background: var(--secondary-colour) !important;
  z-index: 100;

  .start-again {
    padding: 0.75rem;
    width: 100%;
    font-size: 1.5rem;
    box-shadow: var(--box-shadow);
    border: 3px solid var(--action-colour);
    color: var(--action-colour);
    background-color: var(--secondary-colour);
    margin: 0.25rem;
    text-align: center;
  }
  .checkout-button {
    padding: 0.75rem;
    width: 100%;
    font-size: 1.5rem;
    border: 3px solid var(--action-colour);
    box-shadow: var(--box-shadow);
    border: none;
    color: var(--primary-colour);
    background-color: var(--action-colour) !important;
    margin: 0.25rem !important;
  }
}
.cart-buttons {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  margin: 1rem 0;

  .clear-button {
    padding: 1rem;
    width: 5rem;
    font-size: 1.5rem;
    border: 1px solid var(--action-colour);
    color: var(--action-colour);
    background-color: var(--secondary-colour);
    margin: 2px;
  }

  .checkout-button {
    padding: 1rem;
    width: 16rem;
    font-size: 1.5rem;
    border: 3px solid var(--action-colour);
    color: var(--primary-colour);
    margin: 2px;
  }
}

.recent {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  width: calc(100% - 2rem);
}

.order-allergens{
  // background-color: var(--primary-colour);
  background-color: var(--opacity-background);
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  margin: 0.5rem 0;
  h4{
    color: var(--action-colour);
  }
  p{
    color: var(--warning-colour);
    font-weight: bold;
  }
}

@media only screen and (orientation: portrait) {
  .cart {
    border-radius: 0rem;
  }
  .cart-buttons {
    width: 100%;
    .clear-button {
      padding: 0.5rem;
      max-width: 25%;
    }

    .checkout-button {
      max-width: 55%;
    }
  }
}
</style>
